import { Fade, styled } from '@mui/material'
import { Flex } from 'styles'
import { ReactComponent as ArrowSvg } from '../assets/arrow.svg'
import { useRef, useState, useCallback } from 'react'
import { useOnClickOutside } from 'usehooks-ts'
import { SpotOrderDirectionFilterEnum } from 'store/spot/types'

const TypeSidetWrap = styled(Flex)`
  cursor: pointer;
  align-items: center;
  position: relative;
  svg {
    color: ${({ theme }) => theme.color.text50};
    margin-left: 3px;
    transition: all 0.4s ease;
    transform: rotate(180deg);
  }

  &:hover {
    svg {
      color: ${({ theme }) => theme.color.primary30};
      transform: rotate(0deg);
    }
  }
`

const TypeSideMenu = styled('div')`
  position: absolute;
  left: 0px;
  top: calc(100% + 5px);
  box-sizing: content-box;
  display: flex;
  flex-direction: column;
  z-index: 11;
  border-radius: 0px 0px 4px 4px;
  border: 1px solid #2a3139;
  background: #1e2329;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
  padding: 12px 0px;
  width: 145px;
`

const TypeItem = styled(Flex)`
  color: #e5eaee;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 128.571% */
  height: 30px;
  box-sizing: border-box;
  padding-left: 24px;
  align-items: center;
  &:hover {
    background-color: #2a3139;
  }
  &.active {
    color: rgba(160, 238, 9, 1);
  }
`

interface IProps {
  onSelected: (val: SpotOrderDirectionFilterEnum) => any
  filterSide: SpotOrderDirectionFilterEnum
}

const SideSelectPopup = ({ onSelected, filterSide }: IProps) => {
  const selectorWrapRef = useRef<HTMLDivElement>(null)
  const [show, setShow] = useState<boolean>(false)

  const handleClickOutside = useCallback(() => {
    setShow(false)
  }, [])
  useOnClickOutside(selectorWrapRef, handleClickOutside)

  const types = [
    {
      label: 'All',
      key: SpotOrderDirectionFilterEnum.All,
    },
    {
      label: 'Buy',
      key: SpotOrderDirectionFilterEnum.LONG,
    },
    {
      label: 'Sell',
      key: SpotOrderDirectionFilterEnum.SHORT,
    },
  ]
  return (
    <TypeSidetWrap
      ref={selectorWrapRef}
      onMouseEnter={() => {
        setShow(true)
      }}
      onMouseLeave={() => {
        setShow(false)
      }}
    >
      <span>Side</span>
      <ArrowSvg />
      <Fade in={show}>
        <TypeSideMenu>
          {types.map((d, i) => {
            return (
              <TypeItem
                key={i}
                onClick={() => {
                  onSelected(d.key)
                  setShow(false)
                }}
                className={filterSide === d.key ? 'active' : ''}
              >
                {d.label}
              </TypeItem>
            )
          })}
        </TypeSideMenu>
      </Fade>
    </TypeSidetWrap>
  )
}

export { SideSelectPopup }
